import { ReactComponent as ContactSvg } from "./contact.svg";

const ContactIcon = ({ className = "" }) => {
    return <ContactSvg className={className} aria-hidden="true" />;
};

export default ContactIcon;